import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '@screen';
import styled from 'styled-components';

const PlayerTime = styled.span<React.CSSProperties>`
  color: ${Colors['text']};
  font-family: ${Fonts['regular']};
  font-size: ${Screen.widthRatio * 30}px;
`;

export default PlayerTime;
